module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal zoom",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modalAgendar"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.fecharModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Formulário de agendamento")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-left",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('strong', [_vm._v("Dia: "), _c('span', {
    staticClass: "label label-danger",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.formatarData(this.dia)))]), _vm._v(" às "), _c('span', {
    staticClass: "label label-default"
  }, [_vm._v(_vm._s(this.hora))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 text-left"
  }, [_c('h4', [_vm._v("Pesquisa: ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mascaraPesquisa),
      expression: "mascaraPesquisa"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisaView),
      expression: "pesquisaView"
    }],
    ref: "inputPesquisa",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o código da vaga ou CPF"
    },
    domProps: {
      "value": (_vm.pesquisaView)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisar($event)
      }, _vm.verificaMascara],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisaView = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadPesquisa),
      expression: "!loadPesquisa"
    }]
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadPesquisa),
      expression: "loadPesquisa"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resultadoPesquisaVaga),
      expression: "resultadoPesquisaVaga"
    }],
    staticClass: "label label-danger",
    staticStyle: {}
  }, [_vm._v("A pesquisa não retornou nenhum resultado.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isSemCPF),
      expression: "this.isSemCPF"
    }],
    staticStyle: {
      "margin-top": "-45px"
    }
  }, [_c('span', {
    staticClass: "label label-danger",
    staticStyle: {
      "float": "left",
      "margin-top": "30px",
      "margin-bottom": "10px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Não encontramos esse CPF em nossa base de dados.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vNome),
      expression: "vNome"
    }],
    ref: "inputNome",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Digite o Nome Completo"
    },
    domProps: {
      "value": (_vm.vNome)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.adicionaSemCPF($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vNome = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionaSemCPF
    }
  }, [_vm._v(" Adicionar ")])])]), _vm._v(" "), _c('span', {
    staticClass: "label label-default text-left",
    staticStyle: {
      "float": "left",
      "margin-top": "5px",
      "text-align": "left"
    }
  }, [_vm._v("Preencha o nome completo e, depois, clique em Adicionar.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "containerTabela"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resultadoPesquisa.length !== 0 && this.isSemCPF === false),
      expression: "resultadoPesquisa.length !== 0 && this.isSemCPF === false"
    }],
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.resultadoPesquisa), function(row) {
    return (_vm.resultadoPesquisa !== undefined) ? _c('tr', {
      key: row
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.agendamento),
        expression: "agendamento"
      }],
      attrs: {
        "type": "checkbox",
        "title": "Selecionar"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.agendamento) ? _vm._i(_vm.agendamento, row) > -1 : (_vm.agendamento)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.agendamento,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.agendamento = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.agendamento = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.agendamento = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "title": row.RazaoSocial
      }
    }, [_vm._v(" " + _vm._s(row.RazaoSocial == null ? 'N.D.' : row.RazaoSocial.substr(0, 25)) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.IdVaga == null ? 'N.D.' : row.IdVaga))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.IdFichaAprovacao == null ? 'N.D.' : row.IdFichaAprovacao) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.urlCurriculo + row.Guid
      }
    }, [_vm._v(" " + _vm._s(row.Nome) + " ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Cpf))])]) : _vm._e()
  }), 0), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 text-left"
  }, [_c('h4', [_vm._v("Selecionados: ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "min-height": "150px",
      "max-height": "150px",
      "border": "1.2px solid #cdcdcd",
      "border-radius": "4px"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, _vm._l((_vm.agendamento), function(a) {
    return _c('tr', {
      key: a
    }, [_c('td', {
      staticStyle: {
        "border": "1px #cdcdcd",
        "padding": "2px"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "#d9534f"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.tirarDaLista(a)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      staticStyle: {
        "border": "1px #cdcdcd",
        "padding": "2px"
      }
    }, [_vm._v(_vm._s(a.Nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      staticStyle: {
        "border": "1px #cdcdcd",
        "padding": "2px"
      }
    }, [_vm._v(_vm._s(a.Cpf))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row text-left"
  }, [(this.agendamento.length > 0) ? _c('small', {
    staticStyle: {
      "margin-left": "17px",
      "font-style": "italic"
    }
  }, [_vm._v("Você selecionou "), _c('strong', [_vm._v(_vm._s(this.agendamento.length) + " ")]), _vm._v(" pessoa(s). ")]) : _c('small', {
    staticStyle: {
      "margin-left": "17px",
      "font-style": "italic"
    }
  }, [_vm._v("Nenhuma pessoa selecionada. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-left"
  }, [_c('h4', [_vm._v("Observações: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.observacoes),
      expression: "observacoes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "150px",
      "max-height": "150px"
    },
    attrs: {
      "rows": "7",
      "id": "observacoes",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.observacoes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-left"
  }, [_c('small', {
    staticStyle: {
      "margin-left": "17px",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(200 - this.observacoes.length) + " caracteres restantes. ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModal
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-alert",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.outros
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadOutros),
      expression: "!loadOutros"
    }]
  }, [_vm._v("Outros")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadOutros),
      expression: "loadOutros"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rescisao
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadRescisao),
      expression: "!loadRescisao"
    }]
  }, [_vm._v("Rescisão")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadRescisao),
      expression: "loadRescisao"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.admissao
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadAdmissao),
      expression: "!loadAdmissao"
    }]
  }, [_vm._v("Admissão")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadAdmissao),
      expression: "loadAdmissao"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("Empresa")]), _vm._v(" "), _c('td', [_vm._v("Vaga")]), _vm._v(" "), _c('td', [_vm._v("Ficha")]), _vm._v(" "), _c('td', [_vm._v("Nome")]), _vm._v(" "), _c('td', [_vm._v("CPF")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('td', {
    staticClass: " label-primary text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v(" .:: Fim ::.  ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46dd7ac0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/modal/ModalAgendar.vue
// module id = 287
// module chunks = 1